import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { EditorScreen } from "../../areas/editor/EditorScreen";
import { guard } from "../../shared/auth/guards";
import { RouteError } from "../../shared/layout/RouteError";

/**
 * FE-11 FR-FE11-01: the visual editor, outside the `_seller` layout (full screen, no tab bar), guarded
 * for sellers and admins; ownership is enforced by BE-09 (404 → not-found screen). Code-split by the
 * router plugin, so other seller routes never load the editor chunk (NFR-FE11-05).
 */
export const Route = createFileRoute("/app/sites/$siteId/editor")({
  beforeLoad: async (args) => {
    await Promise.all([guard("seller", args), loadNamespaces("editor", "sites")]);
  },
  component: EditorRoute,
  errorComponent: RouteError,
});

function EditorRoute() {
  const { siteId } = Route.useParams();
  return <EditorScreen siteId={siteId} />;
}
